// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"162":"b301498d","205":"a1c0f3d8","312":"60624ec0","408":"1e766df6","848":"c8605aa3","936":"aaa9210b"}[chunkId] + ".js";
};